export default "/images/facebook-logo.png?0512319793439ff1855c28b00845c1e6";